import React, { useState } from 'react';
import { formatMomentDate } from "../../../../../utils/dateHelper";
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import AwardModal from '../../../../../components/modals/UserProfile/AwardModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserAward, updateUserAward, deleteUserAward } from '../../../../../redux/slice/allUsersSlice';
import PreviewModal from '../../../../../components/modals/previewModal';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';
import { UserInital } from '../../../../../utils/otherHelopers';

const Awards = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showPreviewModal, setShowPreviewModal] = useState(false);
    const [previewMediaArray, setPreviewMediaArray] = useState([]);

    const { awardLoading } = useSelector((state) => state.allUsers);

    const handleUpsertAward = (data) => {
        const action = currentItem
            ? updateUserAward({ id: id, awardId: currentItem.id, data })
            : addUserAward({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Award ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} award`);
            });
    };

    const handleDeleteAward = () => {
        dispatch(deleteUserAward({ id: id, awardId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Award deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete award");
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Awards</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />

            </div>
            {userDetail?.awards?.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                    {userDetail.awards.map((award, index) => (
                        <div key={index} className="p-3 border rounded-3 bg-light-subtle position-relative custom-card">
                            <div className="position-absolute top-0 end-0 p-2 d-flex gap-2">
                                <button
                                    className="post-action-btn edit-btn border bg-white"
                                    onClick={() => {
                                        setCurrentItem(award);
                                        setShowModal(true);
                                    }}
                                >
                                    <EditIcon width={14} height={14} color="#007bff" />
                                </button>
                                <button
                                    className="post-action-btn delete-btn border bg-white"
                                    onClick={() => {
                                        setItemToDelete(award.id);
                                        setShowDeletePopup(true);
                                    }}
                                >
                                    <Delete02Icon width={14} height={14} color="#FF0000" />
                                </button>
                            </div>
                            <div className="d-flex gap-3 align-items-start">
                                <UserInital image={award.file.url} name={award.title} width={56} className='cursor-pointer' onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setPreviewMediaArray([{
                                        url: award.file.url,
                                        title: award.title || "Award Image",
                                        type: "image"
                                    }]);
                                    setShowPreviewModal(true);
                                }}
                                    onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />

                                <div className="flex-grow-1">
                                    <h6 className="mb-1 fw-bold text-dark fs-6">{award.title || "-"}</h6>
                                    <div className="d-flex align-items-center flex-wrap gap-2 text-muted mb-2" style={{ fontSize: '13px' }}>
                                        <span className="fw-medium">Awarded by: {award.awarded_by || "-"}</span>
                                        {award.award_date && (
                                            <>
                                                <span style={{ fontSize: '16px', lineHeight: 1 }}>•</span>
                                                <span>{formatMomentDate(award.award_date, "MMM YYYY")}</span>
                                            </>
                                        )}
                                    </div>
                                    {award.description && (
                                        <p className="mb-0 text-secondary text-break mt-1" style={{ lineHeight: '1.6', fontSize: '13px' }}>{award.description}</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No awards listed.</p>
                </div>
            )}

            <AwardModal
                isOpen={showModal}
                onClose={() => {
                    setShowModal(false);
                    setCurrentItem(null);
                }}
                onSubmit={handleUpsertAward}
                award={currentItem}
                isLoading={awardLoading}
                title={currentItem ? "Edit Award" : "Add Award"}
                size="lg"
            />

            <DeletePopup
                show={showDeletePopup}
                onHide={() => {
                    setShowDeletePopup(false);
                    setItemToDelete(null);
                }}
                onConfirm={handleDeleteAward}
                content="Are you sure you want to delete this award?"
                saveTitle="Delete"
                disabled={awardLoading}
            />

            <PreviewModal
                show={showPreviewModal}
                onHide={() => setShowPreviewModal(false)}
                previewMedia={previewMediaArray}
                initialIndex={0}
            />
        </div>
    );
};

export default Awards;
